module.exports = __webpack_public_path__ + "static/media/maple-leaf-homes-logo.55a7bc15.svg";